import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="event-dates-show"
export default class extends Controller {
  static targets = ["date", "moreOptionsBtn"]

  showDates() {
    this.moreOptionsBtnTarget.classList.add("d-none")
    this.dateTargets.forEach(date => date.classList.remove("d-none"))
  }
  addBorder(event){
    event.currentTarget.parentElement.classList.toggle("selected-border")
  }
}
